<template>
  <filter-wrapper
    :label="field.label"
    :removable="removable"
    @removeFilter="removeFilter"
  >
    <b-form-checkbox-group
      v-model="filterData.field.filter.values"
      :options="options"
      stacked
    />
  </filter-wrapper>
</template>
<script>
import filterMixin from "@/components/Tables/Filters/mixins/filterMixin";
import FilterWrapper from "@/components/Tables/Filters/FilterWrapper";
export default {
  components: { FilterWrapper },
  mixins: [filterMixin],
  computed: {
    options: ({ field }) => field.filter.options
  },
  methods: {
    handler(item) {
      let value = item[this.field.key];
      if (typeof this.field.formatter === "function")
        value = this.field.formatter(value, this.field.key, item);
      return this.filterData.field.filter.values.length > 0
        ? this.filterData.field.filter.values.includes(value)
        : true;
    }
  }
};
</script>
